import propType from 'prop-types';
import React, { useEffect, useState } from 'react';

export default function ReadingTimeIndicator({ readingTime, contentRef }) {
  const [remainingTime, setRemainingTime] = useState(readingTime);

  const scrollListener = () => {
    if (contentRef.current) {
      const element = contentRef.current;

      const contentHeigth = element.clientHeight - window.innerHeight || 0;

      const contentStart = element.offsetTop;
      // total height take into account of the window height
      // and the the distance from the top to where the content start
      const contentEnd =
        element.clientHeight + element.offsetTop - window.innerHeight || 0;

      // current scroll y position
      const windowScrollTop =
        // browser compatibility
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      // when scroll-y enter content
      if (windowScrollTop < contentStart) {
        setRemainingTime((prev) => prev * 1);
      } else if (windowScrollTop > contentEnd) {
        setRemainingTime((prev) => prev * 0);
      } else {
        const percentageScroll =
          (windowScrollTop - contentStart) / contentHeigth;
        setRemainingTime(
          readingTime - Math.floor(readingTime * percentageScroll)
        );
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollListener);
    return () => window.removeEventListener('scroll', scrollListener);
  });

  return (
    <div className="reading-time">
      {remainingTime > 0 &&
        `${remainingTime} minute${remainingTime > 1 ? 's' : ''} remaining`}
    </div>
  );
}

ReadingTimeIndicator.propTypes = {
  readingTime: propType.number.isRequired,
  contentRef: propType.shape({
    current: propType.shape({
      clientHeight: propType.number,
      offsetTop: propType.number
    })
  }).isRequired
};
